import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useAuth } from '../../provider/authContextType';

interface OtpValue {
  key: string;
  value: string;
}

interface SendOtpData {
  email?: string;
  phoneNumber?: string;
  verificationMethod?: string;
  names?: string;
  identityDocument?: string;
  identityDocumentTypeId?: string;
}

interface SendOtpRequest {
  conversationRequestId: string;
  idRequest: number;
  responseCode: string;
  responseDescription: string;
}

interface SendVerifyOtpResponse {
  idRequest: number;
  responseCode: string;
  responseDescription: string;
}

const sendOtp = async (
  data: SendOtpData,
  origin: string | null
): Promise<SendOtpRequest> => {
  const response = await axios.post<SendOtpRequest>(
    `${origin}/otp/send`,
    data,
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer `,
      },
    }
  );
  return response.data;
};

const verifyOtp = async (
  idRequest: number,
  otp: string,
  origin: string | null
): Promise<SendVerifyOtpResponse> => {
  const response = await axios.post<SendVerifyOtpResponse>(
    `${origin}/otp/verify`,
    {
      idRequest: idRequest,
      otp: otp,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer `,
      },
    }
  );
  return response.data;
};

export const useSendOtp = () => {
  const { origin } = useAuth();
  return useMutation({
    mutationFn: ({ data }: { data: SendOtpData }) => {
      return sendOtp(data, origin);
    },
  });
};

export const useVerifyOtp = () => {
  const { origin } = useAuth();
  return useMutation({
    mutationFn: ({ idRequest, otp }: { idRequest: number; otp: string }) => {
      return verifyOtp(idRequest, otp, origin);
    },
  });
};
